'use strict';

import React from 'react';

import FaFacebook from 'react-icons/lib/fa/facebook';
import FaLinkedIn from 'react-icons/lib/fa/linkedin';
import FaExternalLink from 'react-icons/lib/fa/external-link';
import FaEnvelope from 'react-icons/lib/fa/envelope';
// import OwlCarousel from 'react-owl-carousel';
// import FaFacebook from 'react-icons/lib/fa/facebook';

function Client(props) {
  const client = props.client;
  client.image = client.image.replace('/api/v1/clients', '');
  if (client.links[0].url != '#') {
    return (
      <div className="item">
        <a href={client.links[0].url}>
          <img src={client.image} alt={client.name} />
        </a>
      </div>
    );
  }
  return (
    <div className="item">
      <img src={client.image} alt={client.name} />
    </div>
  );
}


class Clients extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      clientsArray: []
    }
  }

  componentDidMount() {
    return fetch('/api/v1/clients/')
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          clientsArray: responseJson
        })
      })
      .catch(() => {

      });
  }


  render() {
    const printClients = this.state.clientsArray.map((client) =>
      <Client key={client.name} client={client} />
    );

    return (
      <div className="clients-component" id="clientes">
        <h2 className="title section-title">Clientes</h2>
        <div className="title section-subtitle">
          Prestamos serviços a clientes das mais diversas áreas.
        </div>
        {/* <OwlCarousel className="owl-theme" margin={10} dots={true} lazyLoad={true} responsiveClass={true} autoplay={true}
          responsive={{
            300: {items: 1},
            500: {items: 3},
            1000: {items: 5}
          }}> */}
          <div className="clients">
            { printClients }
          </div>
        {/* </OwlCarousel> */}
      </div>
    );
  }
}

Clients.displayName = 'Clients';

// Uncomment properties you need
// Clients.propTypes = {};
// Clients.defaultProps = {};

export default Clients;



// WEBPACK FOOTER //
// ./src/components/Clients.js